<template>
  <svg
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    stroke-linecap="round"
    stroke-linejoin="round"
    :class="iconClass"
    aria-hidden="true"
  >
    <path d="M10.5 17a6.5 6.5 0 1 1 4.92-2.25" stroke-width="1.9" />
    <path d="m15.2 15.2 4.3 4.3" stroke-width="1.9" />
    <path d="M7.1 3.4 7.5 4.5 8.6 4.9 7.5 5.3 7.1 6.4 6.7 5.3 5.6 4.9 6.7 4.5 7.1 3.4Z" fill="currentColor" stroke="none" />
    <path d="M11.2 5.1 11.45 5.8 12.15 6.05 11.45 6.3 11.2 7 10.95 6.3 10.25 6.05 10.95 5.8 11.2 5.1Z" fill="currentColor" stroke="none" />
    <path d="M9.25 7.2 9.72 8.52 11.05 9 9.72 9.47 9.25 10.8 8.78 9.47 7.45 9 8.78 8.52 9.25 7.2Z" fill="currentColor" stroke="none" />
  </svg>
</template>

<script setup lang="ts">
defineProps<{
  iconClass?: string;
}>();
</script>
